module.exports = __webpack_public_path__ + "img/mage.61e8e105.jpg";